import React from 'react';
import { useCreateMachine } from './presenter';
import { MachineCreateView } from './view';
import { Route } from '../../../components/layout/ProtectedLayout';
import { useConfirm } from '../../../components/ui/ConfirmDialog';
import { useToast } from '../../../components/ui/Toaster';

type Props = {
  navigate: (r: Route) => void;
};

const MachineCreatePage: React.FC<Props> = ({ navigate }) => {
  const vm = useCreateMachine(() => navigate({ name: 'machines/index' }));
  const confirm = useConfirm();
  const toast = useToast();
  return (
    <MachineCreateView
      form={vm.form}
      setField={vm.setField as any}
      onSubmit={async () => {
        const ok = await confirm({ title: 'Save Machine', message: 'Are you sure you want to create this machine?', confirmText: 'Save' });
        if (!ok) return;
        await vm.submit();
        toast.success('Machine created');
      }}
      onCancel={() => navigate({ name: 'machines/index' })}
      loading={vm.loading}
      error={vm.error}
    />
  );
};

export default MachineCreatePage;
